import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ForcePublishService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiBaseUrl;
  }

  forcePublish(alsisProductCodes: string[], receiver: string, itemState: string, isReplaced: boolean | null, isConfigured: boolean | null, suppliers: string[], itemIds: string[], lastModificationDateTimeFrom: Date | null, lastModificationDateTimeTo: Date | null, sendToLegacy: boolean): Observable<any> {
    const payload = {
      AlsisProductCodes: alsisProductCodes,
      Receiver: receiver,
      ItemState: itemState,
      IsReplaced: isReplaced,
      IsConfigured: isConfigured,
      Suppliers: suppliers,
      ItemIds: itemIds,
      LastModificationDateTimeFrom: lastModificationDateTimeFrom,
      LastModificationDateTimeTo: lastModificationDateTimeTo,
      SendToLegacy: sendToLegacy
    };
    return this.http.post(`${this.baseUrl}batchoperations/forcepublish`, payload);
  }
}
